import BigNumber from "bignumber.js";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

const hasMoreThan4Decimals = (value: string): boolean => {
  const bn = new BigNumber(value);
  if (!bn.isFinite()) return false;
  const decimals = bn.decimalPlaces();
  return decimals !== null && decimals > 4;
};

type FullDecimalTooltipProps = {
  value: string;
  displayValue: string;
  className?: string;
};

export function FullDecimalTooltip({
  value,
  displayValue,
  className,
}: FullDecimalTooltipProps) {
  if (!hasMoreThan4Decimals(value)) {
    return <span className={className}>{displayValue}</span>;
  }

  const fullValue = BigNumber(value).toFixed(18);

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span className={className}>{displayValue}</span>
        </TooltipTrigger>
        <TooltipContent className="bg-black text-white font-light text-left max-w-64 px-3 py-1.5 relative overflow-visible">
          {fullValue}
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black m-0"></div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
